export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },

  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    fieldClass: {
      type: [String, Array, Object],
      default: 'inline-block text-grey-40'
    },
    modelValue: {
      default: undefined
    },
    name: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'checkbox'
    }
  },

  watch: {
    checked (newValue) {
      if (newValue !== this.state) {
        this.toggle()
      }
    }
  },

  computed: {
    listeners () {
      let listeners = { ...this.$listeners }

      delete listeners.change
      delete listeners.input

      return listeners
    },

    boxClasses () {
      return [this.$style['box'], this.boxClass, {
        'text-grey-30': this.state,
        [this.$style['checked']]: this.state
      }]
    }
  },

  mounted () {
    if (this.checked && !this.state) {
      this.toggle()
    }
  },

  methods: {
    onChange () {
      this.toggle()
    }
  }
}
